import api from "../../api"
import { QuickBooksAuthorize } from "./quickBooksModel"

export const quickBooksEndpoint = `/quickbooks`

export const getQuickBooksAuthorize = async (): Promise<QuickBooksAuthorize> => {
  return (await api.get<QuickBooksAuthorize>(quickBooksEndpoint + '/authorize')).data
}

export const getQuickBooksDisconnect = async (): Promise<QuickBooksAuthorize> => {
    return (await api.get<QuickBooksAuthorize>(quickBooksEndpoint + '/disconnect')).data
}

export const getQuickBooksConnectionStatus = async (): Promise<boolean> => {
  return (await api.get<boolean>(quickBooksEndpoint + '/status')).data
}

export interface TaxCode {
  id: string;
  name: string;
  description: string;
  salesTaxRateList: TaxRateList;
}

export interface TaxRateList {
  taxRateDetail: TaxRateDetail[];
}

export interface TaxRateDetail {}

export const getQuickBooksSalesTaxes = async (): Promise<TaxCode[]> => {
  return (await api.get<TaxCode[]>(quickBooksEndpoint + '/tax-codes')).data
}